const SITE_URL = 'https://hotto.app';

const KEYS = {
  SHARE_STATS: 'hotto_share_stats',
  REFERRAL: 'hotto_referral',
};

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function appendUtm(url, { source, medium, campaign, content }) {
  const parsed = new URL(url);
  if (source) parsed.searchParams.set('utm_source', source);
  if (medium) parsed.searchParams.set('utm_medium', medium);
  if (campaign) parsed.searchParams.set('utm_campaign', campaign);
  if (content) parsed.searchParams.set('utm_content', content);
  return parsed.toString();
}

export function buildViralSearchUrl(keyword, medium = 'copy') {
  const base = `${SITE_URL}/search/${encodeURIComponent((keyword || '').trim())}`;
  return appendUtm(base, {
    source: 'hotto_share',
    medium,
    campaign: keyword && !isNaN(+String(keyword).trim()) ? 'number_result' : 'dream_result',
    content: (keyword || '').trim(),
  });
}

export function buildViralInviteUrl(medium = 'copy') {
  return appendUtm(SITE_URL, {
    source: 'hotto_invite',
    medium,
    campaign: 'invite_friends',
  });
}

export function buildViralMessage(keyword, mode = 'dream') {
  const trimmed = (keyword || '').trim();
  if (mode === 'number') {
    return `📊 เลข ${trimmed} ถูกบ่อยไหม? มาเช็คสถิติ 32 ปีพร้อมกัน!\n👇 กดลิงก์นี้`;
  }
  return `🔮 ฉันฝันเห็น "${trimmed}" เลขเด็ดคืออะไร?\nมาเช็คพร้อมกันที่ Hotto 👇`;
}

export function buildStreakShareMessage(streak) {
  return `🔥 ฉันเช็คเลขเด็ดที่ Hotto ต่อเนื่อง ${streak} วันแล้ว!\nเธอฝันอะไร? มาเช็คด้วยกัน 👇`;
}

export function buildLineShareUrl(text, url) {
  return `https://line.me/R/msg/text/?${encodeURIComponent(`${text}\n${url}`)}`;
}

export function buildFacebookShareUrl(url) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

export function buildWhatsAppShareUrl(text, url) {
  return `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;
}

export function recordShare(channel) {
  const stats = readJson(KEYS.SHARE_STATS, { total: 0, channels: {} });
  stats.total += 1;
  stats.channels[channel] = (stats.channels[channel] || 0) + 1;
  stats.lastSharedAt = Date.now();
  writeJson(KEYS.SHARE_STATS, stats);
  return stats;
}

export function getShareStats() {
  return readJson(KEYS.SHARE_STATS, { total: 0, channels: {} });
}

export function captureReferralFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  const ref = params.get('ref') || params.get('utm_source');
  if (ref && ref !== 'hotto_share') {
    sessionStorage.setItem(KEYS.REFERRAL, ref);
    return ref;
  }
  return getReferralSource();
}

export function getReferralSource() {
  return sessionStorage.getItem(KEYS.REFERRAL);
}

export function clearReferralSource() {
  sessionStorage.removeItem(KEYS.REFERRAL);
}

export function buildSharePayload(keyword, mode, medium) {
  const url = keyword ? buildViralSearchUrl(keyword, medium) : buildViralInviteUrl(medium);
  const text = keyword ? buildViralMessage(keyword, mode) : '🔮 หาเลขเด็ดจากฝัน เช็คสถิติหวย 32 ปี ฟรีที่ Hotto!';
  return { url, text };
}

export function buildViralTarotUrl(reading, medium = 'copy') {
  const path = reading?.sharePath || '/tarot';
  const base = `${SITE_URL}${path}`;
  const cardNames = reading?.positions?.map((p) => p.card.nameTh).join('-') || 'tarot';
  return appendUtm(base, {
    source: 'hotto_share',
    medium,
    campaign: 'tarot_reading',
    content: cardNames,
  });
}

export function buildTarotShareMessage(reading) {
  if (!reading) return '🔮 เปิดไพ่ยิปซีเลขนำโชคฟรีที่ Hotto';
  const cards = reading.positions.map((p) => p.card.nameTh).join(' · ');
  const nums = reading.luckyNumbers.slice(0, 4).join(', ');
  return `🔮 ไพ่ของฉัน: ${cards}\n✨ เลขนำโชค: ${nums}\nมาเปิดไพ่และเช็คสถิติหวยด้วยกัน 👇`;
}

export function buildTarotSharePayload(reading, medium = 'copy') {
  const url = buildViralTarotUrl(reading, medium);
  const text = buildTarotShareMessage(reading);
  return { url, text };
}
